import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LayoutModule, SharedModule } from '@app/shared';
import { MaterialModule } from '@app/shared/material.module';
import { AddFeatureComponent, FeatureAddEditPageComponent, FeatureListComponent } from '@user/components/feature';

const routes: Routes = [
  { path: 'list', component: FeatureListComponent, data: { title: 'Features' } },
  { path: 'add-edit', component: FeatureAddEditPageComponent, data: { title: 'Feature add-edit' } }
];
@NgModule({
  declarations: [ FeatureListComponent, FeatureAddEditPageComponent, AddFeatureComponent],
  imports: [
    RouterModule.forChild(routes),
    LayoutModule,
    MaterialModule,
    SharedModule
  ],
  entryComponents: [AddFeatureComponent]
})
export class FeatureModule { }
